import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../features/navigation/Navigation';
import Footer from '../features/navigation/Footer';
import './LegalPages.styles.css';

// * [PAGE] Legally compliant Terms & Conditions under Indian Law
export const TermsPage: React.FC = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
    document.title = 'Terms & Conditions | Yash Haldiya';
  }, []);

  return (
    <div className="legal-page-layout">
      <Navigation />

      <main className="legal-page-container">
        <div className="legal-back-nav">
          <Link to="/" className="legal-back-btn">
            <i className="fas fa-arrow-left" /> Back to Portfolio
          </Link>
        </div>

        <article className="legal-document-card">
          <header className="legal-header">
            <span className="legal-badge">Terms of Service</span>
            <h1 className="legal-title">Terms & Conditions</h1>
            <p className="legal-meta">
              Governed under the Laws of India • Effective Date: October 1, 2026
            </p>
          </header>

          <div className="legal-body">
            <section className="legal-section">
              <h2>1. Agreement to Terms</h2>
              <p>
                By accessing or browsing this website (<a href="https://yashhaldiya.com">yashhaldiya.com</a> or associated domains), you agree to be bound by these Terms and Conditions and all applicable laws and regulations of India, including the Information Technology Act, 2000 and the Digital Personal Data Protection Act, 2023. If you do not agree with any of these terms, you are prohibited from using or accessing this site.
              </p>
            </section>

            <section className="legal-section">
              <h2>2. Intellectual Property & Code Samples</h2>
              <p>
                Unless explicitly stated otherwise, the design, brand assets, interactive components, text content, and graphics featured on this website are the proprietary intellectual property of <strong>Yash Haldiya</strong>.
              </p>
              <p>
                Public open-source repositories and code demonstrations linked from this portfolio are governed by their respective licenses (such as MIT or Apache 2.0) as documented in their GitHub repositories.
              </p>
            </section>

            <section className="legal-section">
              <h2>3. Permissible Use</h2>
              <p>You agree not to:</p>
              <ul>
                <li>Use the Website in any manner that could disable, overburden, damage, or impair site infrastructure.</li>
                <li>Attempt to gain unauthorized access to any part of the Website, server, or networks connected to it.</li>
                <li>Transmit spam, unsolicited inquiries, or automated bot traffic through the contact form.</li>
                <li>Scrape, aggregate, or harvest personal data from this platform for unsolicited marketing purposes.</li>
              </ul>
            </section>

            <section className="legal-section">
              <h2>4. Disclaimer of Warranties</h2>
              <p>
                The materials and information on this Website are provided on an &quot;as is&quot; and &quot;as available&quot; basis for professional showcase purposes. Yash Haldiya makes no warranties, expressed or implied, and hereby disclaims all other warranties including, without limitation, implied warranties of merchantability, fitness for a particular purpose, or non-infringement of intellectual property.
              </p>
            </section>

            <section className="legal-section">
              <h2>5. Limitation of Liability</h2>
              <p>
                In no event shall Yash Haldiya be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on this Website, even if notified of the possibility of such damage.
              </p>
            </section>

            <section className="legal-section">
              <h2>6. Governing Law & Jurisdiction</h2>
              <p>
                These terms and conditions are governed by and construed in accordance with the substantive laws of the <strong>Republic of India</strong>. You irrevocably submit to the exclusive jurisdiction of the competent courts located in <strong>Jaipur, Rajasthan, India</strong> for the resolution of any disputes arising out of or related to this Website.
              </p>
            </section>

            <section className="legal-section">
              <h2>7. Inquiries & Contact</h2>
              <p>For any legal or contractual questions regarding these terms, please contact:</p>
              <div className="legal-highlight-box">
                <p><strong>Yash Haldiya</strong></p>
                <p><strong>Location:</strong> Jaipur, Rajasthan, India</p>
                <p><strong>Email:</strong> <a href="mailto:yashaldiya@gmail.com">yashaldiya@gmail.com</a></p>
              </div>
            </section>
          </div>
        </article>
      </main>

      <Footer />
    </div>
  );
};

export default TermsPage;
